import React from "react";
import './Landing.css';

function Landing() {
  return (
    <div className="landing">

    <div className="landingTop">
      <h1>Goal Planner</h1>
    </div>
    
    <p className="landingDesc"> Goal planner is designed to organize your life and help you stay motivated! 
    We have a planner feature, a built-in to-do list, and a journal for you to keep up with your thoughts.</p>
    </div>
  );
}

export default Landing;
